<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>

<h1 class="text-center lifedi-color mb-5">
  รายงานผล
</h1>

<!-- not edit -->
<div *ngIf="!isEdit" class="container pb-5">
  <div class="row d-flex justify-content-center">
    <div class="col-12">
      <form [formGroup]="headerReportForm">
        <div class="form-group row">
          <h5 for="priceReport" class="col-3 col-form-label">ชื่อรายงาน</h5>
          <div class="col-9">
            <input type="text" class="form-control" formControlName="name" id="priceReport" style="width: 100%;">
          </div>
        </div>

        <div class="form-group row p-0">
          <h5 class="col-3 col-form-label">แบบทดสอบ</h5>
          <div class="col-9">
            <select class="custom-select form-control float-left" style="width: 100%;" formControlName="measure_id">
              <option *ngIf="measure.length === 0" value="" selected hidden disabled>ไม่มีแบบทดสอบที่พร้อมทำรายงานผล
              </option>
              <option *ngIf="measure.length > 0" value="" selected hidden disabled>เลือกแบบทดสอบ</option>
              <option *ngFor="let m of measure" [value]="m.MEASURE_ID">{{ m.MEASURE_NAME }}</option>
            </select>
          </div>
        </div>

        <div class="form-group row p-0">
          <h5 class="col-3 col-form-label">สถานะการมองเห็น</h5>
          <div class="col-9">
            <select class="custom-select form-control float-left" style="width: 100%;" formControlName="is_view">
              <option value="" selected hidden disabled>เลือกสถานะการมองเห็น</option>
              <option value="0">Public</option>
              <option value="1">Private</option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <h5 for="coursePic" class="col-3 col-form-label">
            บัญชี
          </h5>
          <div class="col-9">
            <select class="custom-select form-control" style="width: 100%;" formControlName="accountId">
              <option *ngFor="let s of account" [value]="s.ACCOUNTING_ID">
                บัญชี{{ s.ACCOUNTING_NAME }} ({{ s.ACCOUNTING_ID }})
              </option>
            </select>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="row d-flex justify-content-center">
    <lifedi-btn *ngIf="!headerReportForm.valid" disabled="true" lable="ถัดไป"
      customStyle="background-color: rgb(98 101 165); color: #FFF; margin: 10px; padding: 0 30px;">
    </lifedi-btn>
    <lifedi-btn *ngIf="headerReportForm.valid && !reportStatus" lable="ถัดไป" (click)="next(headerReportForm.value)"
      customStyle="background-color: #060E9F; color: #FFF; margin: 10px; padding: 0 30px;">
    </lifedi-btn>
  </div>

  <div *ngIf="reportStatus" class="row my-3 d-flex justify-content-center">
    <div class="col-12 my-3">
      <form [formGroup]="updateForm">
        <mat-checkbox [(ngModel)]="free" [ngModelOptions]="{standalone: true}" (change)="changeStatus('free', free)">
          รายงานผลเบื้องต้น</mat-checkbox>

        <div *ngIf="free" class="form-group my-3">
          <label for="reportFree">คำอธิบายสั้น ๆ ของรายงานผลนี้</label>
          <textarea formControlName="des_free" class="form-control" id="reportFree" rows="3" maxlength="1500"></textarea>
          <p class="text-right">
            <span *ngIf="!updateForm.value.des_free">0</span>
            <span *ngIf="updateForm.value.des_free">{{ updateForm.value.des_free.length | number }}</span>
            /1,500
          </p>
          <div class="pb-3">
            <lifedi-btn lable="กำหนดรูปแบบรายงาน"
              customStyle="background-color: #060E9F; color: #FFF; margin: 20px 5px 20px 0px; padding: 0 30px; position: absolute; right: 10px;"
              (click)="changePage('free')">
            </lifedi-btn>
          </div>
        </div>
      </form>
    </div>

    <div class="col-12 my-3">
      <form [formGroup]="updateForm">
        <mat-checkbox [(ngModel)]="paid" [ngModelOptions]="{standalone: true}" (change)="changeStatus('paid', paid)">
          รายงานผลเชิงลึก</mat-checkbox>

        <div *ngIf="paid" class="form-group my-3">

          <div class="form-group row">
            <h5 for="priceReport" class="col-sm-2 col-form-label">ราคา</h5>
            <div class="col-sm-10">
              <input formControlName="price" type="number" class="form-control" id="priceReport" style="width: 15%;">
            </div>
          </div>

          <label for="reportPaid">คำอธิบายสั้น ๆ ของรายงานผลนี้</label>
          <textarea formControlName="des_paid" class="form-control" id="reportPaid" rows="3" maxlength="1500"></textarea>
          <p class="text-right">
            <span *ngIf="!updateForm.value.des_paid">0</span>
            <span *ngIf="updateForm.value.des_paid">{{ updateForm.value.des_paid.length | number }}</span>
            /1,500
          </p>
          <div class="pb-3">
            <lifedi-btn lable="กำหนดรูปแบบรายงาน"
              customStyle="background-color: #060E9F; color: #FFF; margin: 20px 5px 20px 0px; padding: 0 30px; position: absolute; right: 10px;"
              (click)="changePage('notfree')">
            </lifedi-btn>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div *ngIf="reportStatus" class="row d-flex justify-content-center">
    <lifedi-btn (click)="save(updateForm.value)" lable="บันทึก"
      customStyle="background-color: #005C3D; color: #FFF; margin: 10px; padding: 0 30px;">
    </lifedi-btn>
  </div>
</div>
<!-- not edit -->

<!-- edit -->
<div *ngIf="isEdit && report" class="container pb-5">
  <div class="row d-flex justify-content-center">
    <div class="col-12">
      <form [formGroup]="headerReportForm">
        <div class="form-group row">
          <h5 for="priceReport" class="col-3 col-form-label">ชื่อรายงาน</h5>
          <div class="col-9">
            <input type="text" class="form-control" formControlName="name" id="priceReport" style="width: 100%;">
          </div>
        </div>

        <div class="form-group row p-0">
          <h5 class="col-3 col-form-label">แบบทดสอบ</h5>
          <div class="col-9">
            <p class="form-control" readonly>{{ report.MEASURE_NAME }}</p>
          </div>
        </div>

        <div class="form-group row p-0">
          <h5 class="col-3 col-form-label">สถานะการมองเห็น</h5>
          <div class="col-9">
            <select class="custom-select form-control float-left" style="width: 100%;" formControlName="is_view">
              <option value="" selected hidden disabled></option>
              <option value="0">Public</option>
              <option value="1">Private</option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <h5 for="coursePic" class="col-3 col-form-label">
            บัญชี
          </h5>
          <div class="col-9">
            <select class="custom-select form-control" style="width: 100%;" formControlName="accountId">
              <option *ngFor="let s of account" [value]="s.ACCOUNTING_ID">
                บัญชี{{ s.ACCOUNTING_NAME }} ({{ s.ACCOUNTING_ID }})
              </option>
            </select>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="row my-3 d-flex justify-content-center">
    <div class="col-12 my-3">
      <form [formGroup]="updateForm">
        <mat-checkbox [(ngModel)]="free" [ngModelOptions]="{standalone: true}" (change)="changeStatus('free', free)">
          รายงานผลเบื้องต้น</mat-checkbox>

        <div *ngIf="free" class="form-group my-3">
          <label for="reportFree">คำอธิบายสั้น ๆ ของรายงานผลนี้</label>
          <textarea formControlName="des_free" class="form-control" id="reportFree" rows="3" maxlength="1500"></textarea>
          <p class="text-right">
            <span *ngIf="!updateForm.value.des_free">0</span>
            <span *ngIf="updateForm.value.des_free">{{ updateForm.value.des_free.length | number }}</span>
            /1,500
          </p>
          <div class="pb-3">
            <lifedi-btn lable="กำหนดรูปแบบรายงาน"
              customStyle="background-color: #060E9F; color: #FFF; padding: 0 30px; position: absolute; right: 10px;"
              (click)="changePage('free')">
            </lifedi-btn>
          </div>
        </div>
      </form>
    </div>

    <div class="col-12 my-3">
      <form [formGroup]="updateForm">
        <mat-checkbox [(ngModel)]="paid" [ngModelOptions]="{standalone: true}" (change)="changeStatus('paid', paid)">
          รายงานผลเชิงลึก</mat-checkbox>
        <div *ngIf="paid" class="form-group my-3">

          <div class="form-group row">
            <h5 for="priceReport" class="col-sm-2 col-form-label">ราคา</h5>
            <div class="col-sm-10">
              <input formControlName="price" type="number" class="form-control" id="priceReport" style="width: 15%;">
            </div>
          </div>

          <label for="reportPaid">คำอธิบายสั้น ๆ ของรายงานผลนี้</label>
          <textarea formControlName="des_paid" class="form-control" id="reportPaid" rows="3" maxlength="1500"></textarea>
          <p class="text-right">
            <span *ngIf="!updateForm.value.des_paid">0</span>
            <span *ngIf="updateForm.value.des_paid">{{ updateForm.value.des_paid.length | number }}</span>
            /1,500
          </p>
          <div class="pb-3">
            <lifedi-btn lable="กำหนดรูปแบบรายงาน"
              customStyle="background-color: #060E9F; color: #FFF; padding: 0 30px; position: absolute; right: 10px;"
              (click)="changePage('notfree')">
            </lifedi-btn>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="row d-flex justify-content-center">
    <lifedi-btn (click)="save(updateForm.value)" lable="บันทึก"
      customStyle="background-color: #005C3D; color: #FFF; margin: 10px; padding: 0 30px;">
    </lifedi-btn>
  </div>
</div>
